import { SVGProps, Ref, forwardRef } from 'react';

export const TrashOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.536 5C16.802 2.168 15.124 0 12 0S7.198 2.168 6.464 5H1v1.8h2V16c0 6 2 8 8 8h2c6 0 8-2 8-8V6.8h2V5zm-1.871 0c-.236-.753-.545-1.389-.92-1.884C14.126 2.302 13.291 1.8 12 1.8s-2.127.502-2.744 1.316C8.88 3.61 8.57 4.247 8.336 5zM19.2 6.8H4.8V16c0 2.9.507 4.261 1.223 4.977S8.1 22.2 11 22.2h2c2.9 0 4.261-.507 4.977-1.223S19.2 18.9 19.2 16zM10.4 19v-9H8.6v9zm5-9v9h-1.8v-9z"
                fill="currentColor"
            />
        </g>
    </svg>
));
TrashOutlinedSize24Glyph.displayName = 'TrashOutlinedSize24Glyph';
